<template>
  <main class="cover-auth">
    <div class="widget-sign-up">
      <form class="s20 form" @submit.prevent="handleSubmit">
        <a href="#">
          <div class="text-center mb-8">
            <img src="/public/images/logo-wide.svg" class="auth-logo2" />
          </div>
        </a>

        <h2 class="font-semibold mt-5 mb-4 text-center">Enrôler votre collectivité</h2>

        <div class="s10_mobile container-full-2"> 
          <h2 class="flex align-items-center gap-4 font-medium text-primary-color my-5">
            <img src="/public/icons/icon-info-collectivite.svg" class="size-l" alt="" /> 
            Informations
          </h2>
          
          <div class="form-field-floating lg reactive active my-5">
            <input 
              type="text" 
              class="form-input" 
              name="designation" 
              id="designation" 
              v-model="formData.designation"
              placeholder=""
            >
            <label for="designation">Désignation de la collectivité <b class="color-danger">*</b></label>
          </div>

          <div class="form-field-floating lg reactive active my-5">
            <input 
              type="text" 
              class="form-input" 
              name="registre_commerce" 
              id="registre_commerce" 
              v-model="formData.registreCommerce"
              placeholder=""
            >
            <label for="registre_commerce">Numéro du registre de commerce</label>
          </div>

          <div class="form-field-floating lg reactive my-5">
            <input 
              type="text" 
              class="form-input" 
              name="adresse" 
              id="adresse" 
              v-model="formData.adresse"
              placeholder=""
            >
            <label for="adresse">Adresse de l'entreprise</label>
          </div>

          <div class="form-field-split active my-5">
            <div class="form-field-floating lg reactive half">
              <input 
                type="text" 
                class="form-input" 
                name="telephone" 
                id="telephone" 
                v-model="formData.telephone"
                placeholder=""
              >
              <label for="telephone">Numéro de téléphone <b class="color-danger">*</b></label>
            </div>
            <hr class="hr" />
            <div class="form-field-floating lg reactive half">
              <input 
                type="email" 
                class="form-input" 
                name="email" 
                id="email" 
                v-model="formData.email"
                placeholder=""
              >
              <label for="email">Adresse Email <b class="color-danger">*</b></label>
            </div>
          </div>
        
          <div class="form-field-floating lg reactive">
            <input 
              type="date" 
              class="form-input" 
              name="date_creation" 
              id="date_creation" 
              v-model="formData.dateCreation"
              placeholder=""
            >
            <label for="date_creation">Date de création</label>
          </div>
        </div>  

        <div class="s10_mobile container-full-2">
          <h2 class="flex align-items-center gap-4 font-medium text-primary-color my-5">
            <img src="/public/icons/icon-secteur-activite.svg" class="size-l" alt="" /> 
            Secteur d'activité
          </h2>

          <div class="grid2 grid-row-gap-0">
            <div 
              v-for="secteur in secteurs" 
              :key="secteur.id"
              class="card-check lg single"
            >
              <label class="form-check-label" :for="`secteur_${secteur.id}`">
                <div class="card-check-text">
                  <input 
                    class="form-check-input left" 
                    type="checkbox" 
                    name="secteur" 
                    :id="`secteur_${secteur.id}`" 
                    :value="secteur.value"
                    v-model="formData.secteursActivite"
                  />
                  <h6 class="font-semibold mt-1 mb-2 align-right">{{ secteur.label }}</h6>
                </div>  
              </label>
            </div>
          </div>

          <button type="submit" class="btn lg w-100 flex-center mt-2 mb-7">
            <img src="/public/icons/icon-valider.svg" class="btn-icon" alt="" />
            <span>Créer votre compte</span>
          </button>
          
          <router-link to="/signin">
            <h5 class="text-primary-color text-center">Vous avez déjà un compte ?</h5>
          </router-link>
        </div>
      </form>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue'
import { showAlert } from '@/utils/swal'

interface FormData {
  designation: string
  registreCommerce: string
  adresse: string
  telephone: string
  email: string
  dateCreation: string
  secteursActivite: string[]
}

interface Secteur {
  id: string
  value: string
  label: string
}

export default defineComponent({
  name: 'SignUpCollectivite',
  setup() {
    const secteurs: Secteur[] = [
      { id: 'finance', value: 'Finance', label: 'Finance' },
      { id: 'informatique', value: 'Informatique', label: 'Informatique' },
      { id: 'agriculture', value: 'Agriculture', label: 'Agriculture' },
      { id: 'education', value: 'Éducation', label: 'Éducation' },
      { id: 'sante', value: 'Santé', label: 'Santé' },
      { id: 'transport', value: 'Transport', label: 'Transport' },
      { id: 'construction', value: 'Construction', label: 'Construction' },
      { id: 'commerce', value: 'Commerce', label: 'Commerce' },
      { id: 'industrie', value: 'Industrie', label: 'Industrie' },
      { id: 'autre', value: 'Autre', label: 'Autre' }
    ]

    const formData = reactive<FormData>({
      designation: '',
      registreCommerce: '',
      adresse: '',
      telephone: '',
      email: '',
      dateCreation: '',
      secteursActivite: []
    })

    const handleSubmit = async () => {
      // Validation
      if (!formData.designation) {
        await showAlert.warning('Veuillez saisir la désignation de la collectivité')
        return
      }

      if (!formData.telephone) {
        await showAlert.warning('Veuillez saisir le numéro de téléphone')
        return
      }

      if (!formData.email) {
        await showAlert.warning('Veuillez saisir l\'adresse email')
        return
      }

      if (formData.secteursActivite.length === 0) {
        await showAlert.warning('Veuillez sélectionner au moins un secteur d\'activité')
        return
      }

      // TODO: Appel API pour créer la collectivité
      console.log('Données de la collectivité:', formData)
      await showAlert.success('Collectivité enrôlée avec succès !')
    }

    return {
      secteurs,
      formData,
      handleSubmit
    }
  }
})
</script>

<style scoped>
.grid2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.grid-row-gap-0 {
  row-gap: 0;
}

.card-check {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.card-check:hover {
  border-color: var(--primary-color, #007bff);
  background-color: #f8f9fa;
}

.card-check.single {
  margin-bottom: 0.5rem;
}

.form-check-label {
  cursor: pointer;
  width: 100%;
}

.card-check-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-check-input {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.form-check-input.left {
  margin-right: 0.5rem;
}

.align-right {
  text-align: left;
  flex: 1;
}

@media (max-width: 768px) {
  .grid2 {
    grid-template-columns: 1fr;
  }
}
</style>

